/**
 * Snaptix is off the site for now: the /snaptix-mouthpiece landing 404s, and the Snaptix
 * mouthpieces and banners are left out of every cartridge / all-in-one page.
 * Flip to false to bring it all back.
 */
export const SnaptixHidden = true;
